import { render, staticRenderFns } from "./SMV.vue?vue&type=template&id=184776f3&scoped=true&lang=html&"
import script from "./SMV.vue?vue&type=script&lang=js&"
export * from "./SMV.vue?vue&type=script&lang=js&"
import style0 from "./SMV.vue?vue&type=style&index=0&id=184776f3&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "184776f3",
  null
  
)

component.options.__file = "SMV.vue"
export default component.exports